import { REPLACE_ALL_STATE } from "./actionTypes";
import mainQuery from "./mainQueryReducer";
import model from "./modelReducer";
import lookupData from "./lookupDataReducer";
import userInteraction from "./userInteractionReducer";

export default (state, action) => {
  switch (action.type) {
    case REPLACE_ALL_STATE:
      return action.newState;
    default: {
      if (process.env.REACT_APP_APP_ENV !== "prod") {
        console.debug(`${action.type} - received`, action);
      }
      const newUserInteraction = userInteraction(state.userInteraction, action);

      // A data-driven action (QUERY_COMPLETE, DEMAND_REQUESTS_QUERY_COMPLETE)
      // carries the view mode its hook captured when the effect was scheduled,
      // which can be one render behind a view-mode switch the user made while
      // the query was in flight. userInteraction is the authority on what the
      // page is currently rendering, so the model is always built for that:
      // otherwise the two run out of step, and a forecast model under the
      // constraint view has no constraint cells to render (it throws on the
      // first one, and the page ends up on the error boundary).
      const modelAction =
        action.viewMode && action.viewMode !== newUserInteraction.viewMode
          ? { ...action, viewMode: newUserInteraction.viewMode }
          : action;

      const newState = {
        ...state,
        mainQuery: mainQuery(state.mainQuery, action),
        model: model(state.model, modelAction),
        lookupData: lookupData(state.lookupData, action),
        userInteraction: newUserInteraction,
      };

      if (process.env.REACT_APP_APP_ENV !== "prod") {
        console.debug(`${action.type} - complete`, {
          state: newState,
        });
      }
      return newState;
    }
  }
};
